"use strict";
import './../../sass/magazine.sass';
document.addEventListener('DOMContentLoaded', () => {
    const form = document.getElementById('fn_magazine-form');
    const input = document.getElementById('fn_search-input');
    if (form && input) {
        form.addEventListener('submit', (e) => {
            e.preventDefault();
            const inputValue = input.value.trim();
            const searchQuery = inputValue.replace(/\s+/g, '+');
            form.action = '/magazin/v/' + searchQuery;
            form.submit();
        });
    }
});
